let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("0co4q")).then(() => parcelRequire('flVrS'));